import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { updateUserDetailsById } from '../../services/authService';

const Profile = () => {
  const { state } = useAuth();
  const { user } = state;
  const [succesmsg, setSuccessMsg] = useState(null)

  console.log(user,"useruseruser")

  const [profileData, setProfileData] = useState({
    first_name: '',
    last_name: '',
    invitation_type: '',
    status: '',
    password: '',
    location: null,
    pass_updated_time: null
  });

  useEffect(() => {
    if (user) {
      setProfileData({
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        invitation_type: user.invitation_type || '',
        // password: user.password || '',
        location: user.location || null,
      });
    }
  }, [user]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const updatedUser = await updateUserDetailsById({
        id: user.user_id,
        data: profileData
      });
      if (updatedUser) {
        setSuccessMsg(updatedUser.message)
      }
      ////console.log('Profile updated successfully:', updatedUser.message);
      // Optionally, show a success message or update the UI
    } catch (error) {
      console.error('Failed to update profile:', error);
      // Optionally, show an error message
    }
  };

  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  };
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <header className="flex justify-between items-center bg-white p-4 shadow-md">
        <div>
          <h1 className="text-xl text-gray-700" style={{ fontFamily: 'Poppins, sans-serif'}}>Welcome, {profileData.first_name} {profileData.last_name || ""}</h1>
        </div>
        {succesmsg && (
          <div className="flex items-center bg-green-50 border border-green-300 text-green-800 rounded-md p-4 my-4 shadow-md transition-transform transform hover:scale-105">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-600 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M15 12h6M3 12h6M3 6h18M3 18h18" />
            </svg>
            <span className="font-medium">{succesmsg}</span>
          </div>
        )}
        <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center">
          {getInitials(user.first_name, user.last_name)}
        </div>
      </header>

      <main className="mt-6">
        <form onSubmit={handleSave} className="bg-white p-6 rounded-lg shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-700">First Name</label>
              <input
                type="text"
                name="first_name"
                value={profileData.first_name}
                onChange={handleChange}
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              />
            </div>
            <div>
              <label className="block text-gray-700">Last Name</label>
              <input
                type="text"
                name="last_name"
                value={profileData.last_name}
                onChange={handleChange}
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              />
            </div>
            {/* <div>
              <label className="block text-gray-700">Invitation Type</label>
              <input
                type="text"
                name="invitation_type"
                value={profileData.invitation_type}
                onChange={handleChange}
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              />
            </div> */}
            {/* <div>
              <label className="block text-gray-700">Status</label>
              <input
                type="text"
                name="status"
                value={profileData.status}
                onChange={handleChange}
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              />
            </div> */}
            {/* <div>
              <label className="block text-gray-700">Password</label>
              <input
                type="password"
                name="password"
                value={profileData.password}
                onChange={handleChange}
                placeholder="Enter new password"
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              />
            </div> */}
            {/* <div>
              <label className="block text-gray-700">Location</label>
              <input
                type="text"
                name="location"
                value={profileData.location || ''}
                onChange={handleChange}
                placeholder="Enter location"
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              />
            </div> */}
          </div>
          <div className="mt-6">
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
              Save
            </button>
          </div>
        </form>
        <div className="mt-6">
          <h3 className="text-lg text-gray-700" style={{ fontFamily: 'Poppins, sans-serif'}}>My email Address</h3>
          <div className="flex items-center mt-4">
            <i className="fas fa-envelope text-blue-500"></i>
            <div className="ml-4">
              <p className="text-gray-700">{user.user_name}</p>
              <p className="text-gray-500 text-sm">1 month ago</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Profile;
